export default __webpack_public_path__ + "static/media/demoQR.ca2f984f.png";